import { reloadGoogleMap } from 'assets/utils/reloadGoogleMap';
import React, { useEffect } from 'react';

type LocationsMapProps = {
	coords?: Array<Array<number>>;
	iconUrl?: string;
	url?: string;
};

declare global {
	interface Window {
		displayMap: (coords: Array<Array<number>>, iconUrl: string) => any;
	}
}

const LocationsMap = (props: LocationsMapProps): JSX.Element => {
	const { coords, iconUrl } = props;
	useEffect(() => {
		if (typeof window != undefined && coords && iconUrl) {
			window.displayMap = () => {
				var bound = new window.google.maps.LatLngBounds();
				for (var i = 0; i < coords.length; i++) {
					bound.extend(new window.google.maps.LatLng(coords[i][0], coords[i][1]));
				}

				const mapOptions = {
					center: bound.getCenter(),
					zoom: 10,
				};
				const mapDiv = document.getElementById('map-container');
				if (mapDiv) {
					const map = new google.maps.Map(mapDiv, mapOptions);

					for (let i = 0; i < coords.length; i++) {
						const marker = new google.maps.Marker({
							position: {
								lat: coords[i][0],
								lng: coords[i][1],
							},
							map: map,
							label: {
								text: (i + 1).toString(),
								color: '#fff',
								fontSize: '20px',
							},
							icon: {
								url: `${iconUrl}`,
								scaledSize: new window.google.maps.Size(44, 44),
							},
						});

						marker.addListener('click', function () {
							const coords = this.getPosition()?.lat() + ', ' + this.getPosition()?.lng();
							const result = document.querySelector(`[data-coords="${coords}"]`);
							result && result.scrollIntoView();
						});
					}
					return map;
				} else {
					return;
				}
			};
		}

		if (!window?.google?.maps) {
			reloadGoogleMap(
				'https://maps.googleapis.com/maps/api/js?key=AIzaSyAjtlB7VsJ0SmtNzMGXyw0_EmSXQvd6qBk&libraries=places&sensor=false&loading=async&callback=displayMap'
			);
		}
	}, []);

	return <>{props.coords ? <div className="map-container"></div> : <p>map w url</p>}</>;
};

export default LocationsMap;
